import { MessageCircleQuestion } from "lucide-react";

import { SECTION_TYPES } from "@/lib/constants/sections";

import type { ServiceSection } from "@/types/sections";

const faqsSection: ServiceSection = {
  type: SECTION_TYPES.FAQS,
  content: {
    header: "Frequently Asked Questions",
    subheader: "Here's what people ask us",
    showIcon: true,
    questions: [
      {
        q: "What services does your business offer?",
        a: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur",
      },
      {
        q: "How do I get an estimate for my project?",
        a: "Mattis ullamcorper velit sed ullamcorper morbi tincidunt. Quam id leo in vitae turpis massa sed. Sed tempus urna et pharetra pharetra massa. Adipiscing tristique risus nec feugiat in. Leo urna molestie at elementum eu facilisis sed. Eget mi proin sed libero enim sed faucibus turpis. Sed libero enim sed faucibus turpis in eu mi. Mi sit amet mauris commodo quis imperdiet massa.",
      },
      {
        q: "What areas do you service?",
        a: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur",
      },
    ],
  },
  meta: {
    displayName: "FAQs",
    displayDescription: "Answer common questions your customers have.",
    displayIcon: MessageCircleQuestion,
    variantsCount: 2,
  },
  aiPrompt() {
    return "For the FAQs section, anticipate the most common questions and concerns that visitors may have. Provide clear, informative, and reassuring answers that build trust and credibility. Use this section to address any potential objections or hesitations that visitors may have. DO NOT MENTION ANYTHING ABOUT BEING ECO FRIENDLY. Limit to 6 FAQs.";
  },
};

export default faqsSection;
